import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectCashierPage } from './select-cashier.page';

const routes: Routes = [
  {
    path: '',
    component: SelectCashierPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectCashierPageRoutingModule {}
